import { z } from "zod";
import { IEmsConnectorInfo_MaxLoadUnit } from "@/api/Enums";

export const phaseRotationsSchema = z.enum([
  "L1L2L3",
  "L1L3L2",
  "L2L1L3",
  "L2L3L1",
  "L3L1L2",
  "L3L2L1"
]);

export const ConnectorDetailsSchema = z.object({
  connectors: z
    .object({
      emsConnectorInfo: z.object({
        phaseRotation: z.string(),
        maxLoad: z.coerce.number(),
        maxLoadUnit: z.nativeEnum(IEmsConnectorInfo_MaxLoadUnit)
      })
    })
    .array()
});

export type ConnectorDetailsSchema = z.infer<typeof ConnectorDetailsSchema>;
